<template>
    <v-dialog v-model="editorShownHotel" width="850" persistent>
        <!-- Begin:v-card:Mode:update -------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid violet;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: violet;" class="b-fa b-fa-hotel"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Hotels List -------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: violet; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Hotels:</strong></div>
            <selected-hotels-list v-model="employees" v-if="editorShownHotel" />

            <v-divider style="margin-top: 20px;"></v-divider>

            <!-- Selecting Hotel ------------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: violet; padding-right: 10px;" class="b-fa b-fa-hotel"></i><strong>Choose the Hotel:</strong></div>
            <v-card-text class="pa-5" style="position: relative;">
                <!-- Countries, Hotels -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <countries-combo v-model="country" label="Select Country:" v-if="editorShownHotel" />
                    </v-col>
                    <v-col cols="6" class="smallerHeight">
                        <hotels-combo v-model="hotel" label="Select Hotel:" v-if="editorShownHotel" />
                    </v-col>
                </v-row>

                <!-- Date Times -->
                <datetime v-model="startDate" label="Arrival - from" disabled="false" disabledTime="false" ref="startTimer" style="padding-top: 25px !important;" />
                <datetime v-model="endDate" label="Departure - to" disabled="false" disabledTime="false" ref="endTimer" />

                <!-- >>> Hotel Comment -->
                <comment-textarea v-model="comment" label="Hotel Info:" style="padding-top: 25px !important;" maxlength="50" />
                <!-- <<< Hotel Comment -->

                <!-- Make visile Button -->
                <!-- <v-btn absolute dark fab top right color="#ab3b7a"><v-icon>mdi-eye</v-icon></v-btn> -->
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('HOTEL').length }} Hotel(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_HotelDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Update_Hotel"> Save</v-btn>
            </v-card-actions>
        </v-card>
        <!-- End:v-card:Mode:update ---------------------------------------- -->



        <!-- Begin:v-card:Mode:create -------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid violet;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: violet;" class="b-fa b-fa-hotel"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: violet; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownHotel" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting Hotel ------------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: violet; padding-right: 10px;" class="b-fa b-fa-hotel"></i><strong>Choose the Hotel:</strong></div>
            <v-card-text class="pa-5" style="position: relative;">
                <!-- Countries, Hotels -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <countries-combo v-model="country" label="Select Country:" v-if="editorShownHotel" />
                    </v-col>
                    <v-col cols="6" class="smallerHeight">
                        <hotels-combo v-model="hotel" label="Select Hotel:" v-if="editorShownHotel" />
                    </v-col>
                </v-row>

                <!-- Date Times -->
                <datetime v-model="startDate" label="Arrival - from" disabled="false" disabledTime="false" ref="startTimer" style="padding-top: 25px !important;" />
                <datetime v-model="endDate" label="Departure - to" disabled="false" disabledTime="false" ref="endTimer" />

                <!-- >>> Hotel Comment -->
                <comment-textarea v-model="comment" label="Hotel Info:" style="padding-top: 25px !important;" maxlength="50" />
                <!-- <<< Hotel Comment -->

                <!-- Make visile Button -->
                <!-- <v-btn absolute dark fab top right color="#ab3b7a"><v-icon>mdi-eye</v-icon></v-btn> -->
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_HotelDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Create_Hotel"> Save</v-btn>
            </v-card-actions>
        </v-card>
        <!-- End:v-card:Mode:create ---------------------------------------- -->
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import CountriesCombo from '../../CountriesCombo.vue';
    import HotelsCombo from '../../HotelsCombo.vue';
    import SelectedHotelsList from '../../SelectedHotelsList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';
    import CommentTextarea from '../../CommentTextarea.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-hotel',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownHotel
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            CountriesCombo,
            HotelsCombo,
            SelectedHotelsList,
            SelectedEmployeesList,
            CommentTextarea,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            country         : null,
            hotel           : null,
            comment         : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_selectedMultiEvents', // get: selected Events
                'get_selectedMultiResources', // get: selected Resources
                'get_Hotels',
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownHotel()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownHotel: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/hotel/EventEditor.vue >>> editorShownHotel get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    country         : null,
                                    hotel           : null,
                                    comment         : null,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    country         : null,
                                    hotel           : null,
                                    comment         : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownHotel get()

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/hotel/EventEditor.vue >>> editorShownHotel set');
                    this.$emit('input', value);

                } // eo editorShownHotel set()

            } // eo function editorShownHotel()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updateoffice'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> created');
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_create_Multiple_Hotels',  // Call: Create Multiple Hotels,
                'actn_update_Multiple_Hotels',  // Call: Update Multiple Hotels,
                'actn_set_SelectedMultiEvents',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_Update_Hotel()
            *
            * Desc: 'Update Hotel(s)' - Call.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_Update_Hotel: function(){

                let me = this,
                    singleParamObject = {},
                    params = {
                        stay : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> onSave_Update_Hotel');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        checkinDate     : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        checkoutDate    : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        idHotel         : me.hotel ? me.hotel.hotelid : null,
                        id              : employee.originalId,
                        idResources     : [employee.resourceId],
                        comment         : me.comment,
                        status          : employee.hotelObject.status
                    };
                    params.stay.push(singleParamObject);
                });

                if (this.validateParams_Update(params) === true) {
                    this.actn_update_Multiple_Hotels(params);
                    this.onClose_HotelDialog();
                }

            }, // eo function onSave_Update_Hotel()


            /*******************************************************************
            * onSave_Create_Hotel()
            *
            * Desc: 'Create Hotel(s)' - Call.
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_Create_Hotel: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> onSave_Create_Hotel');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    idHotel         : me.hotel ? me.hotel.hotelid : null,
                    idResources     : this.employees,
                    checkinDate     : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    checkoutDate    : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    comment         : me.comment,
                };

                if (this.validateParams_Create(params) === true) {
                    this.actn_create_Multiple_Hotels(params);
                    this.onClose_HotelDialog();
                }

            }, // eo function onSave_Create_Hotel()


            /*******************************************************************
            * onClose_HotelDialog()
            *
            * Desc:
            * Note:
            *
            */
            onClose_HotelDialog: function(){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> onClose_HotelDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array, #244
                me.editorShownHotel = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_HotelDialog()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> onChange_DatePicker');
                // newDate = new Date(value);
                // newDate.setHours(23);
                // newDate.setMinutes(59);
                // me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams_Update()
            *
            * Desc: Validate Params before Update.
            * Note:
            *
            * @param {Object} params (Params we want to send (update))
            */
            validateParams_Update: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> validateParams_Update');
                // >>> -------------------------- 'resources?'                  // Check 1
                if (params.stay.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.stay[0].checkinDate);
                    endDate = moment(params.stay[0].checkoutDate);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                // >>> -------------------------- 'idHotel?'                    // Check 3
                if (valid === true) {  // still valid
                    if (params.stay[0].idHotel === null || params.stay[0].idHotel === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Hotel is a required field.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams_Update()


            /*******************************************************************
            * validateParams_Create()
            *
            * Desc: Validate Params before Create.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams_Create: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/hotel/EventEditor.vue >>> validateParams_Create');
                // >>> -------------------------- 'resources?'                   // Check 1
                if (params.idResources === null || params.idResources === undefined || params.idResources.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.checkinDate);
                    endDate = moment(params.checkoutDate);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                // >>> -------------------------- 'idHotel?'                    // Check 3
                if (valid === true) {  // still valid
                    if (params.idHotel === null || params.idHotel === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Hotel is a required field.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams_Create()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .smallerHeight {
        padding-top: 0px;
        padding-bottom: 0px;
    }


    .v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
        top: -68px;
    }
</style>
